'use strict';

var ChartDashboardScheduleDataService = function ChartDashboardScheduleDataService(dataRetrieverService, dataRetrieverConstantsService) {
  var dataRetriever = dataRetrieverService.getDataRetriever(dataRetrieverConstantsService.DASHBOARD_SCREEN, dataRetrieverConstantsService.MARKET_DASHBOARD_MODE);
  function getData() {
    return dataRetriever.localSortApplied().retrieveComponentData('dashboard-schedule');
  }
  return {
    getData: getData
  };
};
ChartDashboardScheduleDataService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = ChartDashboardScheduleDataService;